import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuthService } from "../../authentication/auth.service";
import { ApiServiceBase } from "../../base/api-service-base";
import { PaymentAcquirerReferenceCommandModel, PaymentAcquirerReferenceModel, PaymentAcquirerSearch } from "../../models/payment-acquirer-model";
import { PaymentAcquirerUpdateStatusCode } from "src/app/modules/settings-management/settings-categories-content/payment-definition/payment-acquirer/search/payment-acquirer-search.model";
import { PaymentAcquirerSort, PaymentAcquirerUpdateSortSequence } from "../../models/payment-acquirer-model/payment-acquirer-sort.model";

@Injectable({
    providedIn: 'root'
})
export class PaymentAcquirerReferenceService extends ApiServiceBase {
    private readonly PATH = '/system/paymentacquirerreferences';
    constructor(httpClient: HttpClient, authService: AuthService) {
        super(httpClient, authService);
    }


    public updateStatusCode(obj: PaymentAcquirerUpdateStatusCode): Observable<never> {
        return this.httpPut<never>(this.PATH + '/updatestatus', obj)
            .pipe(
                map(res => res.body)
            )
    }

    public search(statusCode?: string, paymentAcquirerName?: string, paymentAcquirerCode?: string): Observable<PaymentAcquirerSearch[]> {
        const queryParams = new HttpParams({ fromObject: <any>{ statusCode, paymentAcquirerName, paymentAcquirerCode } })
        return this.httpGet<PaymentAcquirerSearch[]>(`${this.PATH}/search`, queryParams)
            .pipe(
                map(res => res.body)
            )
    }

    public get(paymentAcquirerCode: string): Observable<PaymentAcquirerReferenceModel> {
        return this.httpGet<PaymentAcquirerReferenceModel>(this.PATH + "/code/" + paymentAcquirerCode, null)
            .pipe(
                map(res => res.body)
            )
    }
    
    public add(command: PaymentAcquirerReferenceCommandModel): Observable<PaymentAcquirerReferenceModel> {
        return this.httpPost<PaymentAcquirerReferenceModel>(this.PATH, command)
            .pipe(
                map(res => res.body)
            )
    }

    public edit(command: PaymentAcquirerReferenceCommandModel): Observable<PaymentAcquirerReferenceModel> {
        return this.httpPut<PaymentAcquirerReferenceModel>(this.PATH, command)
            .pipe(
                map(res => res.body)
            )
    }
    public getSort(): Observable<PaymentAcquirerSort[]> {
        return this.httpGet<PaymentAcquirerSort[]>(this.PATH + "/sort", null)
            .pipe(
                map(res => res.body)
            )
    }
    public updateSortSequence(items: PaymentAcquirerUpdateSortSequence[]): Observable<never> {
        return this.httpPut<never>(this.PATH + "/sort", items)
            .pipe(
                map(res => res.body)
            )
    }  
}